<div class="ade-page">
  <div class="ade-page__loading" *ngIf="isLoading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading && page">
    <div class="ade-page__content">
      <ng-container *ngFor="let widget of page?.content; let i = index">
        <ng-container *ngIf="widget.__component === 'widgets.image'">
          <div [class]="getResponsiveClasses(widget)">
            <widget-image [widget]="widget"></widget-image>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'shared.title'">
          <div class="ade-listing__widge mt-14 mb-8">
            <h1
              [style.text-align]="widget.textAlign || 'left'"
              style="
                font-size: 48px;
                text-transform: uppercase;
                font-weight: 300;
                font-style: normal;
                text-decoration: none;
                letter-spacing: 5px;
                font-family: &quot;Lato&quot;, serif !important;
                font-size: 32px !important;
                color: var(--ade-gold-meta, #ab9311) !important;
              "
            >
              {{ widget.title }}
            </h1>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.block-title'">
          <div
            [class]="
              getResponsiveClasses(widget) +
              ' md:col-start-3 lg:col-start-3 xl:col-start-3'
            "
          >
            <widget-title
              [widget]="widget"
              elementClasses="mt-14 mb-8 pb-0 about-title"
            ></widget-title>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.editor-text'">
          <div
            [class]="
              getResponsiveClasses(widget) +
              ' md:col-start-3 lg:col-start-3 xl:col-start-3 md:col-span-8'
            "
          >
            <widgets-editor-text
              [widget]="widget"
              elementClasses="mb-14"
            ></widgets-editor-text>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'shared.text'">
          <div
            [class]="
              getResponsiveClasses(widget) +
              ' md:col-start-3 lg:col-start-3 xl:col-start-3 md:col-span-8'
            "
          >
            <div
              class="ade-page__text"
              [style.text-align]="widget.textAlign || 'left'"
              [innerHTML]="widget.body"
            ></div>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.gallery'">
          <div class="col-span-1 md:col-span-12 mb-10">
            <widget-gallery [widget]="widget"></widget-gallery>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.video'">
          <div [class]="getResponsiveClasses(widget)">
            <widget-video [widget]="widget"></widget-video>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.form'">
          <div
            class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3"
          >
            <widget-form [widget]="widget"></widget-form>
          </div>
        </ng-container>

        <ng-container
          *ngIf="widget.__component === 'widgets.section-image-title-text'"
        >
          <widgets-image-title-text
            class="col-span-1 md:col-span-12"
            [widget]="widget"
          ></widgets-image-title-text>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.banner'">
          <div class="col-span-1 md:col-span-12">
            <widget-banner [widget]="widget"></widget-banner>
          </div>
        </ng-container>

        <ng-container
          *ngIf="widget.__component === 'widgets.block-title-description'"
        >
          <div [class]="getResponsiveClasses(widget)">
            <widget-block-title-description
              [widget]="widget"
            ></widget-block-title-description>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <div class="ade-page__empty" *ngIf="!isLoading && !page">
    {{ "Conteúdo não disponível." | transloco }}
  </div>
</div>
